import { AppRoutes } from "./appRoutes";
import ScrollToTop from "./components/scrollToTop";
import Navbar from "./components/navbar/navbar";
import Footer from "./components/footer";
import { useLocation } from "react-router-dom";
import FacebookPixel from "./components/facebookPixel";
import { useEffect } from "react";
import { useMetaDataStore } from "./store/metadataStore";
import { useMetaStore } from "./store/data";

function App() {

  const location = useLocation()
  const path = location.pathname
  const fetchStateData = useMetaDataStore((state) => state.fetchMetaData)
  const fetchMetaData = useMetaStore((state)=>state.fetchMetaData)

  useEffect(()=>{
    fetchStateData()
    fetchMetaData()
  },[])

  return (
    <>
      <FacebookPixel />
      {path !== "/create-account" && <Navbar />}
      <main>
        <AppRoutes />
        <ScrollToTop />
      </main>
      {(path !== "/create-account" && path !== "/practitioner-register" && path !== "/my-account") && <Footer />}
    </>
  );
}

export default App;
